import { Link } from 'react-router-dom';
import { rankingBoards } from '@/mocks/rankings';

export default function RankingsPreview() {
  const board = rankingBoards[0];

  return (
    <section id="rankings" className="px-4 md:px-10 py-16 md:py-20 bg-foreground-950 text-background-100" aria-label="榜单盘点预览">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-4 mb-10">
        <div>
          <span className="text-xs tracking-[0.3em] text-accent-400 font-medium">RANKING BOARDS</span>
          <h2 className="mt-3 font-heading text-2xl md:text-4xl font-black text-background-50">榜单盘点：把重点排成名次</h2>
          <p className="mt-3 text-sm text-background-300 max-w-xl leading-relaxed">
            专题负责归类，榜单负责排序。我们从讨论量、渗透率与完读率三个维度，定期更新各个分类的名次。
          </p>
        </div>
        <Link
          to="/rankings"
          className="inline-flex items-center gap-2 h-11 px-5 rounded-md bg-accent-500 text-primary-950 text-sm font-medium hover:bg-accent-400 transition-colors cursor-pointer whitespace-nowrap w-fit"
        >
          查看全部榜单
          <i className="ri-arrow-right-line"></i>
        </Link>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-10">
        <div className="lg:col-span-8">
          <div className="flex items-center justify-between pb-4 border-b border-background-100/20">
            <h3 className="font-heading text-lg md:text-xl font-bold text-background-50">{board.title}</h3>
            <span className="text-xs text-background-400">{board.period}</span>
          </div>
          <ul className="mt-2">
            {board.items.map((item) => (
              <li
                key={item.rank}
                className="flex items-start gap-4 md:gap-6 py-5 border-b border-background-100/10 last:border-0"
              >
                <span
                  className={`w-11 h-11 md:w-12 md:h-12 shrink-0 rounded-md flex items-center justify-center font-heading font-black text-lg md:text-xl ${
                    item.rank <= 3 ? 'bg-primary-500 text-background-50' : 'bg-background-100/10 text-background-300'
                  }`}
                >
                  {item.rank}
                </span>
                <div className="flex-1 min-w-0">
                  <div className="flex flex-wrap items-center gap-3">
                    <h4 className="font-heading text-base md:text-lg font-bold text-background-50">{item.title}</h4>
                    <span className="px-2 py-0.5 rounded-full text-[11px] bg-secondary-500/20 text-secondary-200 border border-secondary-500/30">
                      {item.tag}
                    </span>
                  </div>
                  <p className="mt-2 text-sm text-background-300 leading-relaxed">{item.desc}</p>
                </div>
                <span className="hidden sm:block text-xs text-accent-400 whitespace-nowrap pt-1">{item.metric}</span>
              </li>
            ))}
          </ul>
        </div>

        <aside className="lg:col-span-4 flex flex-col gap-5">
          <div className="rounded-lg bg-background-50/5 border border-background-100/15 p-6">
            <h3 className="font-heading text-lg font-bold text-background-50">榜单怎么排的</h3>
            <ul className="mt-4 space-y-4 text-sm text-background-300 leading-relaxed">
              <li className="flex gap-3">
                <i className="ri-pulse-line text-accent-400 mt-0.5"></i>
                <span>讨论量：统计话题在一周内被提及的总时长与频次。</span>
              </li>
              <li className="flex gap-3">
                <i className="ri-water-flash-line text-accent-400 mt-0.5"></i>
                <span>渗透率：衡量一个说法进入日常语言的速度与广度。</span>
              </li>
              <li className="flex gap-3">
                <i className="ri-book-open-line text-accent-400 mt-0.5"></i>
                <span>完读率：反映专题的完整度与阅读体验。</span>
              </li>
            </ul>
          </div>
          <div className="rounded-lg bg-primary-500 p-6">
            <h3 className="font-heading text-lg font-bold text-background-50">想推荐新榜单？</h3>
            <p className="mt-3 text-sm text-primary-100 leading-relaxed">
              告诉我们你觉得值得单独排序的主题，我们会评估是否立项。
            </p>
            <Link
              to="/about"
              className="mt-5 inline-flex items-center gap-2 text-sm font-medium text-background-50 hover:text-accent-300 transition-colors cursor-pointer"
            >
              去关于我们页面留言
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </aside>
      </div>
    </section>
  );
}